import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";
import { PROJECTS } from "@/data/projects";
import InteractiveBentoGallery from "@/components/InteractiveBentoGallery";

const FILTERS = [
  { key: "all", label: "All projects", tid: TID.portfolio.filterAll },
  { key: "homeowner", label: "Homeowners", tid: TID.portfolio.filterHome },
  { key: "builder", label: "Builders & developers", tid: TID.portfolio.filterBuilder },
];

export default function Portfolio() {
  const [filter, setFilter] = useState("all");

  const visibleProjects = useMemo(() => {
    const list =
      filter === "all"
        ? PROJECTS
        : PROJECTS.filter((p) => p.audience === filter);
    return list.map((p) => ({
      id: p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-"),
      title: p.title,
      sub: p.sub,
      type: p.type,
      budget: p.budget,
      time: p.time,
      audience: p.audience,
      tag: p.audience === "builder" ? "Builder" : "Homeowner",
      images: p.images,
    }));
  }, [filter]);

  return (
    <section
      id="portfolio"
      data-testid={TID.portfolio.root}
      className="relative bg-charcoal text-cream py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <p className="text-[11px] tracking-[0.32em] uppercase text-cream/60 mb-8">
          The Collection
        </p>
        <h2 className="font-display font-light text-[10vw] md:text-[5.6vw] leading-[0.98] tracking-tightest">
          Quietly remarkable projects.
        </h2>
        <p className="mt-6 max-w-xl text-cream/70 text-sm md:text-base">
          Open any project to step inside. The dock at the bottom lets you
          flick between every photo in that home.
        </p>

        <div
          data-testid={TID.portfolio.filter}
          className="mt-10 inline-flex p-1 border border-cream/15 bg-[#1a1816] gap-1"
        >
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={f.tid}
              onClick={() => setFilter(f.key)}
              className={`relative text-[11px] tracking-[0.28em] uppercase px-5 py-3 transition-colors duration-300 ${
                filter === f.key
                  ? "text-charcoal"
                  : "text-cream/65 hover:text-cream"
              }`}
            >
              {filter === f.key && (
                <motion.span
                  layoutId="filter-pill"
                  className="absolute inset-0 bg-brass"
                  transition={{ type: "spring", stiffness: 380, damping: 30 }}
                />
              )}
              <span className="relative">{f.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-14 md:mt-16">
          <InteractiveBentoGallery projects={visibleProjects} />
        </div>
      </div>
    </section>
  );
}
